/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import SvgExternal from '@digital-hig/icon/lib/build/icons/navigation/external';
import { Button, SvgIcon } from '@mui/material';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import BannerRootElement from './style';
import { extractContent } from '../../utils/profile.util';

const HeroBanner = (props) => {
  const {
    displayName, contactLink, title, loading, translate, page,
  } = props || {};
  const { t } = useTranslation();

  return (
    <BannerRootElement>
      <Box className="page-container" data-testid="Banner">
        <Typography
          variant="headline-larger"
          className="banner-title"
          component={page === 'story' ? 'h2' : 'h1'}
        >
          {!loading && translate ? translate(displayName) : displayName}
          {loading && <Skeleton width="35%" />}
        </Typography>
        <Typography
          variant="body-copy-small"
          className="sub-title"
          component="h2"
        >
          {!loading && title && extractContent(translate ? translate(title) : title)}
          {loading && <Skeleton width="30%" />}
        </Typography>
        <Box className="dhig-theme--dark">
          {!loading && (
            <Button
              startIcon={<SvgIcon fontSize="medium"><SvgExternal /></SvgIcon>}
              variant="contained"
              href={contactLink}
              data-wat-loc="hero contact"
              data-wat-val="contact us"
              target="_blank"
              className="contact-bt"
            >
              {t('Contact partner')}
            </Button>
          )}
          {loading && <Skeleton width="140px" />}
        </Box>
      </Box>
    </BannerRootElement>
  );
};
export default HeroBanner;
